<form [formGroup]="configurationForm" (ngSubmit)="onSubmit()" class="grid gap-4 pt-2">
  <mat-form-field class="w-full">
    <mat-label>Logo URL</mat-label>
    <input matInput formControlName="logo" type="text" />
  </mat-form-field>

  <mat-form-field class="w-full">
    <mat-label>Notification email</mat-label>
    <input matInput formControlName="notificationEmail" type="email" />
    @if (configurationForm.get('notificationEmail')?.hasError('email')) {
      <mat-error>Enter a valid email address</mat-error>
    }
  </mat-form-field>

  <mat-form-field class="w-full">
    <mat-label>Max number of dependents</mat-label>
    <input matInput formControlName="maxNumberOfDependents" type="number" />
  </mat-form-field>

  <mat-form-field class="w-full">
    <mat-label>Client portal access</mat-label>
    <mat-select formControlName="canAccessClientPortal">
      <mat-option value="true">Enabled</mat-option>
      <mat-option value="false">Disabled</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field class="w-full">
    <mat-label>Face to face cases allowed</mat-label>
    <input matInput formControlName="faceToFaceCasesAllowed" type="number" />
  </mat-form-field>

  <mat-form-field class="w-full">
    <mat-label>Telephonic cases allowed (% of headcount)</mat-label>
    <input matInput formControlName="telephonicCasesAllowedPercentageOfHeadcount" type="number" />
  </mat-form-field>

  <mat-form-field class="w-full">
    <mat-label>Sessions allowed per case</mat-label>
    <input matInput formControlName="sessionsAllowedPerCase" type="number" />
  </mat-form-field>

  <button mat-raised-button color="primary" type="submit" [disabled]="configurationForm.invalid || saving()">
    Save
  </button>
</form>